import { Facebook, Instagram, Linkedin, Mail } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-border bg-card">
    {/* Main footer */}
    <div className="container py-10 sm:py-14">
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
        {/* Brand + socials — full width on mobile */}
        <div className="col-span-2 sm:col-span-2 lg:col-span-1">
          <a href="/" className="font-display text-xl font-bold text-foreground">
            Integra<span className="text-gradient">Doc</span> GT
          </a>
          <p className="text-sm text-muted-foreground mt-3 max-w-xs">
            Soluciones de gestión documental, digitalización y automatización de procesos en Guatemala.
          </p>
          <div className="flex items-center gap-3 mt-5 flex-wrap">
            <a href="https://wa.me/50233823427?text=Hola%2C%20quiero%20contactarme%20para%20los%20servicios%20de%20gesti%C3%B3n%20documental." target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center text-white hover:opacity-80 transition-opacity">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            </a>
            <a href="mailto:herberaldana@integradocgt.com" className="w-9 h-9 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:text-primary transition-colors">
              <Mail className="w-4 h-4" />
            </a>
            <a href="https://www.instagram.com/integradocgt" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:text-primary transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="https://www.tiktok.com/@integradocgt" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:text-primary transition-colors">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.75a8.18 8.18 0 004.76 1.52V6.84a4.84 4.84 0 01-1-.15z"/></svg>
            </a>
            <a href="https://www.facebook.com/integradocgt" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:text-primary transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="https://www.linkedin.com/company/integradoc-gt/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:text-primary transition-colors">
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Empresa */}
        <div>
          <h4 className="font-semibold text-foreground mb-3 sm:mb-4">Empresa</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><a href="/nosotros" className="hover:text-primary transition-colors">Sobre Nosotros</a></li>
            <li><a href="/#servicios" className="hover:text-primary transition-colors">Servicios</a></li>
            <li><a href="/#docuware" className="hover:text-primary transition-colors">DocuWare</a></li>
            <li><a href="/#videos" className="hover:text-primary transition-colors">Cómo Funciona</a></li>
          </ul>
        </div>

        {/* Recursos */}
        <div>
          <h4 className="font-semibold text-foreground mb-3 sm:mb-4">Recursos</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><a href="/blog" className="hover:text-primary transition-colors">Blog</a></li>
            <li><a href="/#faq" className="hover:text-primary transition-colors">FAQ</a></li>
            <li><a href="/#contacto" className="hover:text-primary transition-colors">Contacto</a></li>
            <li><a href="/nosotros#capacitacion" className="hover:text-primary transition-colors">Capacitación</a></li>
          </ul>
          <div className="mt-4 text-sm text-muted-foreground">
            <h4 className="font-semibold text-foreground mb-3 sm:mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><a href="/privacidad" className="hover:text-primary transition-colors">Política de Privacidad</a></li>
              <li><a href="/terminos" className="hover:text-primary transition-colors">Términos de Servicio</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-border">
      <div className="container py-4 sm:py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs sm:text-sm text-muted-foreground text-center">
        <span>© 2026 IntegraDoc GT. Todos los derechos reservados.</span>
        <span>
          Hecho con ❤️ por{" "}
          <a href="https://aikonversa.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors underline">
            Aikonversa.com
          </a>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
